'use client';

import ProductDetailsAdapter from 'components/padi-product/product-details/helpers/adapter';
import { TasticProps } from 'frontastic/tastics/types';
import { memo } from 'react';
import { Product } from 'shared/types/product/Product';
import { DataSource } from 'types/datasource';

type ProductDetailsDataSource = DataSource<{
  product: Product;
}> & {
  isTurnOnGallery?: boolean;
  isLazyLoad?: boolean;
};

const ProductDetailsTastic = ({ data, projectConfig }: TasticProps<ProductDetailsDataSource>) => {
  if (!data?.data?.dataSource?.product) {
    return <div className="h-auto min-h-[430px]"></div>;
  }

  return (
    <div className="h-auto min-h-[430px]">
      <ProductDetailsAdapter
        product={data?.data?.dataSource.product}
        projectConfig={projectConfig}
        isLazyLoad={data?.isLazyLoad}
        isTurnOnGallery={data?.isTurnOnGallery}
      />
    </div>
  );
};

export default memo(ProductDetailsTastic);
